import { Box, Card, CardContent, Divider, Grid, Stack, Tabs, Typography } from "@mui/material";
import { useMemo, useState } from "react";
import { Link } from "react-router-dom";
import Iconify from "src/components/iconify";
import StyledSoftTab from "src/components/styled-soft-tab";
import { TwitterInsightsDetail } from "src/types/platforms/twitter";

const TwitterInsightsDetails = ({ data }: { data: TwitterInsightsDetail[] }) => {
  const [value, setValue] = useState(0);
  const tabs = useMemo(() => data.map((item) => item.title), [data]);
  const current = data[value]?.value;

  if (!data.length || !current) return null;

  const meta = [
    { icon: "mdi:calendar-clock-outline", label: "Tweet Date", value: current["Tweet Date"] },
    { icon: "mdi:emoticon-outline", label: "Sentiment", value: current["Tweet Sentiment"] },
    { icon: "mdi:account-outline", label: "Author", value: current["Author Name"] },
    { icon: "mdi:account-multiple-outline", label: "Followers", value: current["Author Followers"] },
    { icon: "mdi:heart-outline", label: "Likes", value: current["Tweet Likes"] },
    { icon: "mdi:repeat-variant", label: "Retweets", value: current["Tweet Retweets"] },
    { icon: "mdi:comment-outline", label: "Replies", value: current["Tweet Replies"] },
    { icon: "mdi:eye-outline", label: "Views", value: current["Tweet Views"] },
  ].filter((item) => item.value);

  return (
    <Card>
      <CardContent>
        <Stack spacing={2}>
          <Typography>Tweet Insights</Typography>
          <Divider
            sx={{
              borderStyle: "dashed",
              opacity: 0.24,
              borderColor: "#0B1D60",
            }}
          />

          <Tabs
            value={value}
            TabIndicatorProps={{
              style: {
                display: "none",
              },
            }}
          >
            {tabs.map((tab, index) => (
              <StyledSoftTab key={tab} selected={value === index} title={tab} onClick={() => setValue(index)} />
            ))}
          </Tabs>

          <Stack spacing={1.5}>
            {current["Tweet Text"] && (
              <Typography variant="body1" fontWeight="bold">
                {current["Tweet Text"]}
              </Typography>
            )}

            {current["Tweet Link"] && (
              <Typography variant="caption" color="text.disabled">
                Tweet Link:{" "}
                <Link
                  to={current["Tweet Link"]!}
                  target="_blank"
                  style={{
                    textDecoration: "none",
                  }}
                >
                  {current["Tweet Link"]}
                </Link>
              </Typography>
            )}

            {meta.length > 0 && (
              <Grid container spacing={2}>
                {meta.map((item) => (
                  <Grid item key={item.label}>
                    <Card>
                      <CardContent
                        sx={{
                          bgcolor: "#F1F1F5",
                          p: "2.25px",
                          paddingBottom: "1.25px !important",
                          borderRadius: 10,
                        }}
                      >
                        <Stack direction="row" alignItems="center" spacing={1}>
                          <Box display="flex" alignItems="center">
                            <Iconify icon={item.icon} width={20} height={20} />
                          </Box>
                          <Typography variant="caption" color="#555770" fontWeight="bold">
                            {item.value}
                          </Typography>
                        </Stack>
                      </CardContent>
                    </Card>
                  </Grid>
                ))}
              </Grid>
            )}
          </Stack>
        </Stack>
      </CardContent>
    </Card>
  );
};

export default TwitterInsightsDetails;
